import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import Hero from "./components/Hero";
import CategoryNav from "./components/CategoryNav";
import PopularArticles from "./components/PopularArticles";
import FeaturedTopics from "./components/FeaturedTopics";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

export default function Home() {
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "第一次指南",
    url: "https://nervousnix.github.io",
    description: "「第一次」完全指南——从紧张到自信的蜕变。无论你面对的是哪种「第一次」，这里都有你需要的准备清单、心理疏导与实战技巧。",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://nervousnix.github.io/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "第一次指南",
    url: "https://nervousnix.github.io",
    description: "专注于「第一次」经验分享的中文内容平台，帮助每一位用户从紧张到自信地迎接人生中的全新体验。",
    foundingDate: "2025",
  };

  const webpageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "「第一次」完全指南——首页",
    description: "无论你面对的是哪种「第一次」，这里都有你需要的准备清单、心理疏导与实战技巧。告别焦虑，让每一个「第一次」都成为人生高光时刻。",
    url: "https://nervousnix.github.io",
    isPartOf: { "@type": "WebSite", name: "第一次指南", url: "https://nervousnix.github.io" },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageSchema)}</script>

      <main>
        <Navbar />
        <Hero />
        <CategoryNav />
        <PopularArticles />
        <FeaturedTopics />
        <FAQSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}